module.exports = __webpack_public_path__ + "static/img/about_cooperate_06_zh.4ae920d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_cooperate_06_zh.png
// module id = J2cx
// module chunks = 34